import * as React from 'react'
import { useForm } from './Form'
import { InputWrapper, Label, ErrorMessage, InputElement } from './styled'

const { useState, useEffect } = React

type ValidationFn = (value: any) => true | string

interface InputProps {
  type: string
  name: string
  label?: string | null
  validate?: ValidationFn
}

export const Input: React.FC<InputProps> = ({
  name,
  type,
  label,
  validate,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const { values, markValidity, updateField } = useForm()
  const value = values[name]

  useEffect(() => {
    if (!validate) return
    const result = validate(value)
    const isValid = result === true
    markValidity(name, isValid)
    if (typeof result === 'string') {
      setErrorMessage(result)
    }
  }, [value, validate])

  return (
    <InputWrapper>
      {label ? <Label htmlFor={name}>{label}</Label> : null}
      <InputElement type={type} value={value} onChange={updateField(name)} />
      {errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : null}
    </InputWrapper>
  )
}
